/**
 * Errors Command Group
 * Manage local error logs: list, show, clear
 */
import { Command } from 'commander';
import chalk from 'chalk';
import { createErrorsListSubcommand } from './list.js';
import { createErrorsShowSubcommand } from './show.js';
import { createErrorsClearSubcommand } from './clear.js';

function showErrorsHelp(): void {
  console.log(chalk.bold.cyan('🧾 jai1 errors') + chalk.dim(' - Quản lý error logs cục bộ'));
  console.log();
  console.log(chalk.bold('Các lệnh:'));
  console.log(`  ${chalk.cyan('list')}      Danh sách error logs`);
  console.log(`  ${chalk.cyan('show')}      Xem chi tiết error log`);
  console.log(`  ${chalk.cyan('clear')}     Xoá error logs`);
  console.log();
  console.log(chalk.bold('Ví dụ:'));
  console.log(chalk.dim('  $ jai1 errors list'));
  console.log(chalk.dim('  $ jai1 errors show <id>'));
  console.log(chalk.dim('  $ jai1 errors clear --all'));
  console.log();
  console.log(chalk.dim('Chạy "jai1 errors <lệnh> --help" để xem chi tiết'));
}

export function createErrorsCommand(): Command {
  const errorsCommand = new Command('errors')
    .description('Manage local error logs')
    .action(() => {
      showErrorsHelp();
    });

  errorsCommand.addCommand(createErrorsListSubcommand());
  errorsCommand.addCommand(createErrorsShowSubcommand());
  errorsCommand.addCommand(createErrorsClearSubcommand());

  return errorsCommand;
}
